import { BaseEdge, EdgeLabelRenderer, getBezierPath } from 'reactflow';

interface ConditionEdgeProps {
	id: string;
	sourceX: number;
	sourceY: number;
	targetX: number;
	targetY: number;
	sourcePosition: any;
	targetPosition: any;
	data?: {
		condition?: string;
		label?: string;
	};
	style?: React.CSSProperties;
	markerEnd?: string;
}

export function ConditionEdge({
	id,
	sourceX,
	sourceY,
	targetX,
	targetY,
	sourcePosition,
	targetPosition,
	data,
	style,
	markerEnd,
}: ConditionEdgeProps) {
	const [edgePath, labelX, labelY] = getBezierPath({
		sourceX,
		sourceY,
		sourcePosition,
		targetX,
		targetY,
		targetPosition,
	});

	const condition = data?.condition || 'success';
	const label = data?.label || '';

	// Determine edge styling based on condition
	const getEdgeStyle = () => {
		const baseStyle = {
			strokeWidth: 2,
			...style,
		};

		switch (condition) {
			case 'true':
				return {
					...baseStyle,
					stroke: '#10b981', // Green for true
					strokeDasharray: 'none',
				};
			case 'false':
				return {
					...baseStyle,
					stroke: '#ef4444', // Red for false
					strokeDasharray: '5,5', // Dashed for false
				};
			default:
				return {
					...baseStyle,
					stroke: '#6b7280', // Gray for default
					strokeDasharray: 'none',
				};
		}
	};

	const getLabelStyle = () => {
		const baseStyle = {
			fontSize: '12px',
			fontWeight: '500',
			padding: '2px 6px',
			borderRadius: '4px',
			pointerEvents: 'all',
		};

		switch (condition) {
			case 'true':
				return {
					...baseStyle,
					backgroundColor: '#10b981',
					color: 'white',
				};
			case 'false':
				return {
					...baseStyle,
					backgroundColor: '#ef4444',
					color: 'white',
				};
			default:
				return {
					...baseStyle,
					backgroundColor: '#6b7280',
					color: 'white',
				};
		}
	};

	return (
		<>
			<BaseEdge path={edgePath} markerEnd={markerEnd} style={getEdgeStyle()} />
			<EdgeLabelRenderer>
				<div
					style={{
						position: 'absolute',
						transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
						...getLabelStyle(),
					}}
					className="nodrag nopan"
				>
					{label || (condition === 'true' ? '✓ True' : '✕ False')}
				</div>
			</EdgeLabelRenderer>
		</>
	);
}
